export default "__VITE_ASSET__DXoA01I7__"